var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveiconsmainactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_427_30196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6 3H14.4V6C14.4 6.5 14 6.8 13.6 6.8H10.5C10 6.8 9.6 6.5 9.6 6V3H5.4C4.1 3 3 4.1 3 5.4V18.6C3 19.9 4.1 21 5.4 21H18.6C19.9 21 21 19.9 21 18.6V5.4C21 4.1 19.9 3 18.6 3Z",
    fill: "#5070DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_427_30196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveiconsmainactive);
export default __webpack_public_path__ + "static/media/saveiconsmainactive.dc418ab02878e1353c1416f9a1fba9de.svg";
export { ForwardRef as ReactComponent };